import React from "react";

import { MenuContext } from "../contexts/menu";

export const useMenu = () => {
    return React.useContext(MenuContext);
}